import { Link } from "react-router-dom";
import { categories } from "@/mocks/content";

export default function CategoryStrip() {
  return (
    <section className="w-full px-4 md:px-8 -mt-14 relative z-20">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
            按主题翻看
          </h2>
          <span className="text-xs md:text-sm text-foreground-500">共 6 个分类 · 持续更新</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col gap-2 p-4 rounded-lg bg-background-100 border border-transparent hover:border-secondary-300 transition-colors cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className={`${c.icon} text-xl`} />
              </span>
              <span className="font-heading text-sm md:text-base font-bold text-foreground-900">
                {c.name}
              </span>
              <span className="text-xs text-foreground-500">{c.count} 条内容</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}